export default function Services() {
  const services = [
    {
      title: 'Masaje Descontracturante',
      description: 'Ideal para quienes "acaban tensos" y necesitan liberar cargas musculares profundas.',
      benefits: [
        'Alivia tensiones musculares profundas',
        'Mejora la movilidad y flexibilidad',
        'Reduce el dolor crónico'
      ],
      icon: 'ri-hand-heart-line',
      image: 'https://static.readdy.ai/image/5ec0a551afa550ea327b68ffd2fc4f5a/70df229d0e02226437008010c93559e1.png'
    },
    {
      title: 'Masaje Relajante Espectacular',
      description: 'Una experiencia "sanadora" para desconectar del mundo y salir renovado.',
      benefits: [
        'Reduce el estrés y la ansiedad',
        'Mejora la calidad del sueño',
        'Restaura el equilibrio emocional'
      ],
      icon: 'ri-leaf-line',
      image: 'https://public.readdy.ai/ai/img_res/d9e512ac7887ecb32a7ab09e2242a9d7.jpg'
    },
    {
      title: 'Masaje Deportivo',
      description: 'Potencia tu recuperación con manos expertas que entienden el rendimiento físico.',
      benefits: [
        'Acelera la recuperación muscular',
        'Previene lesiones deportivas',
        'Optimiza el rendimiento atlético'
      ],
      icon: 'ri-run-line',
      image: 'https://readdy.ai/api/search-image?query=professional%20sports%20massage%20therapy%20athletic%20recovery%20treatment%20expert%20therapist%20hands%20working%20on%20athlete%20leg%20muscles%20quadriceps%20and%20calves%20deep%20tissue%20technique%20performance%20enhancement%20injury%20prevention%20modern%20clinical%20spa%20environment%20focused%20therapeutic%20pressure%20muscle%20rehabilitation%20fitness%20wellness%20athletic%20care&width=800&height=600&seq=service-deportivo-premium-003&orientation=landscape'
    }
  ];

  return (
    <section id="servicios" className="py-24 bg-[#FAFAF8]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-serif text-5xl font-medium text-[#2C3E2F] mb-4">
            Nuestros Servicios Estrella
          </h2>
          <div className="w-20 h-1 bg-[#A8B5A0] mx-auto"></div>
        </div>

        <div className="space-y-10">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-gradient-to-r from-[#A8B5A0]/10 to-white rounded-[32px] overflow-hidden hover:shadow-2xl transition-all duration-300 h-[280px] flex flex-col md:flex-row"
            >
              {/* Image Area */}
              <div className="relative w-full md:w-2/5 h-48 md:h-full">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-[#2C3E2F]/20"></div>
                <div className="absolute top-4 right-4 w-12 h-12 flex items-center justify-center bg-white/90 rounded-full">
                  <i className={`${service.icon} text-2xl text-[#A8B5A0]`}></i>
                </div>
              </div>

              {/* Content Area */}
              <div className="w-full md:w-3/5 p-8 md:p-12 flex flex-col justify-between">
                <div>
                  <h3 className="font-serif font-bold text-3xl text-[#2C3E2F] mb-4">
                    {service.title}
                  </h3>
                  <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                    {service.description}
                  </p>
                  <ul className="space-y-2">
                    {service.benefits.map((benefit, idx) => (
                      <li key={idx} className="flex items-center text-sm text-gray-600">
                        <i className="ri-checkbox-circle-fill text-[#A8B5A0] mr-2"></i>
                        {benefit}
                      </li>
                    ))}
                  </ul>
                </div>
                {service.title !== 'Masaje Relajante Espectacular' && (
                  <div className="mt-6">
                    <a
                      href="#reserva"
                      className="inline-flex items-center px-6 py-2 border-2 border-[#A8B5A0] text-[#2C3E2F] rounded-full hover:bg-[#A8B5A0] hover:text-white transition-all duration-300 whitespace-nowrap"
                    >
                      Reservar ahora
                      <i className="ri-arrow-right-line ml-2"></i>
                    </a>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
